import React, { createContext, useContext, useEffect, useState } from "react";
export type CaptionStyle = 'closed' | 'karaoke' | 'modern';
export type PlayerSize = 'extra-small' | 'small' | 'medium' | 'large';
export interface PlayerContextInterface {
  captionStyle: CaptionStyle;
  setCaptionStyle: (style: CaptionStyle) => void;
  playerSize: PlayerSize;
  setPlayerSize: (size: PlayerSize) => void;
}
export const PlayerLayoutContext = createContext<PlayerContextInterface>({
  captionStyle: 'modern',
  setCaptionStyle: () => {},
  playerSize: 'medium',
  setPlayerSize: () => {}
});
export const usePlayerLayoutContext = () => useContext(PlayerLayoutContext);
export const PlayerLayoutContextProvider = ({
  children,
  width
}: {
  children: React.ReactNode;
  width: number;
}) => {
  const [captionStyle, setCaptionStyle] = useState<CaptionStyle>('modern');
  console.log("Media width", width);
  const [playerSize, setPlayerSize] = useState<PlayerSize>(calculatePlayerSize(width));
  useEffect(() => {
    const playerSize = calculatePlayerSize(width);
    setPlayerSize(playerSize);
    console.log('setPlayerSize', playerSize);
  }, [width]);
  return <PlayerLayoutContext.Provider value={{
    captionStyle,
    setCaptionStyle,
    playerSize,
    setPlayerSize
  }} data-sentry-element="unknown" data-sentry-component="PlayerLayoutContextProvider" data-sentry-source-file="PlayerLayoutContext.tsx">
            {children}
        </PlayerLayoutContext.Provider>;
};
export function calculatePlayerSize(width: number): PlayerSize {
  console.log('Calculate player size', width);
  if (width < 350) {
    return 'extra-small';
  } else if (width < 500) {
    return 'small';
  } else if (width < 1000) {
    return 'medium';
  } else {
    return 'large';
  }
}